<template>
  <div class="cat-new">
    <b-row>
      <b-col cols="12">
        <h4>Quản trị Vinh Danh nhân viên CSKH
        </h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8" sm="6" xs="12">
        <b-input-group class="input-group-merge">
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon"/>
          </b-input-group-prepend>
          <b-form-input id="searchbar" v-model="searchQuery" class="search-new"
                        placeholder="Nhập nội dung tìm kiếm" v-on:keydown.enter="quickSearch"/>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-1 cat-sub">
      <b-col md="4" sm="6" xs="12">
        <b-card class="text-center" no-body>
          <b-card-body>
                <span v-for="(f, stt) in categoryList" :key="stt">
                  <b-row class="tree-item ">
                    <b-col v-b-toggle="'collapse-' + f.id" :aria-controls="'collapse-' + f.id" :aria-expanded="f.isShow == true ? 'true' : 'false'" md="9"
                           sm="9" xs="9">
                      <b-row>
                        <b-col class="parent-item" md="10" sm="10" xs="10">
                          <b-form-input v-if="f.editMode" v-model="f.name" placeholder="Nhập danh mục" type="text"/>
                          <label v-else class="tree-item-text ">{{ f.name }}
                          </label>
                        </b-col>
                        <b-col class="right-tonggle" md="2" sm="2" xs="2">
                          <div :class="f.isShow ? 'bt-tonggle-expand' : 'bt-tonggle-collspan'">
                            <div class="icon-img"></div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="3" sm="3" xs="3">
                      <b-row v-if="f.editMode">
                        <div class="btn-tree-parent" role="button" @click="cancelEditCate(f)">
                          <svg fill="none" height="20" viewBox="0 0 20 20" width="20"
                               xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" fill="#FF5A5A" r="10"/>
                            <path
                                d="M11.3222 10.0043L15.3534 5.53551C15.53 5.33936 15.6291 5.07333 15.6291 4.79593C15.6291 4.51853 15.53 4.2525 15.3534 4.05635C15.1769 3.8602 14.9375 3.75 14.6878 3.75C14.4382 3.75 14.1987 3.8602 14.0222 4.05635L10.0003 8.53551L5.97843 4.05635C5.8019 3.8602 5.56247 3.75 5.31281 3.75C5.06315 3.75 4.82372 3.8602 4.64718 4.05635C4.47065 4.2525 4.37147 4.51853 4.37147 4.79593C4.37147 5.07333 4.47065 5.33936 4.64718 5.53551L8.67843 10.0043L4.64718 14.473C4.55931 14.5698 4.48957 14.6851 4.44197 14.812C4.39438 14.9389 4.36987 15.0751 4.36987 15.2126C4.36987 15.3501 4.39438 15.4863 4.44197 15.6132C4.48957 15.7401 4.55931 15.8553 4.64718 15.9522C4.73434 16.0498 4.83803 16.1273 4.95227 16.1802C5.06651 16.2331 5.18905 16.2603 5.31281 16.2603C5.43657 16.2603 5.55911 16.2331 5.67335 16.1802C5.78759 16.1273 5.89128 16.0498 5.97843 15.9522L10.0003 11.473L14.0222 15.9522C14.1093 16.0498 14.213 16.1273 14.3273 16.1802C14.4415 16.2331 14.564 16.2603 14.6878 16.2603C14.8116 16.2603 14.9341 16.2331 15.0484 16.1802C15.1626 16.1273 15.2663 16.0498 15.3534 15.9522C15.4413 15.8553 15.511 15.7401 15.5586 15.6132C15.6062 15.4863 15.6307 15.3501 15.6307 15.2126C15.6307 15.0751 15.6062 14.9389 15.5586 14.812C15.511 14.6851 15.4413 14.5698 15.3534 14.473L11.3222 10.0043Z"
                                fill="white"/>
                          </svg>
                        </div>
                        <div class="btn-tree-parent" role="button" @click="saveEditCate(f)">
                          <svg fill="none" height="20" viewBox="0 0 20 20" width="20"
                               xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" fill="#6FC959" r="10"/>
                            <path
                                d="M8.49491 16.25C8.38334 16.2495 8.27304 16.2197 8.17087 16.1624C8.06869 16.105 7.97681 16.0214 7.90095 15.9167L3.94662 10.5312C3.79881 10.3296 3.71962 10.061 3.72649 9.78456C3.73335 9.50814 3.82571 9.24653 3.98324 9.05729C4.14077 8.86805 4.35056 8.76667 4.56648 8.77546C4.78239 8.78425 4.98673 8.90249 5.13455 9.10416L8.48677 13.6771L15.3295 4.09375C15.399 3.98304 15.4854 3.89168 15.5834 3.82527C15.6814 3.75887 15.789 3.71881 15.8996 3.70758C16.0101 3.69635 16.1213 3.71417 16.2263 3.75995C16.3313 3.80573 16.4278 3.8785 16.51 3.9738C16.5923 4.06909 16.6584 4.1849 16.7044 4.31411C16.7503 4.44331 16.7752 4.58319 16.7774 4.72514C16.7796 4.8671 16.7592 5.00814 16.7173 5.13959C16.6754 5.27105 16.6129 5.39015 16.5337 5.48958L9.09701 15.9062C9.02186 16.0129 8.9303 16.0984 8.82809 16.1576C8.72587 16.2168 8.61521 16.2482 8.50304 16.25H8.49491Z"
                                fill="white"/>
                          </svg>
                        </div>
                        <div class="btn-tree-parent" role="button" @click="sortCate(f)">

                        </div>
                      </b-row>
                      <b-row v-else>
                        <div class="btn-tree-parent" role="button" @click="editNewCate(f)">
                          <svg fill="none" height="19" viewBox="0 0 19 19" width="19"
                               xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4.22877 18H16.0704C16.1566 18 16.2428 18.0353 16.309 18.1038C16.3759 18.1729 16.4163 18.2702 16.4163 18.375C16.4163 18.4798 16.3759 18.5771 16.309 18.6462C16.2428 18.7148 16.1566 18.75 16.0704 18.75H4.22877C4.14262 18.75 4.05643 18.7148 3.99017 18.6462C3.92335 18.5771 3.88293 18.4798 3.88293 18.375C3.88293 18.2702 3.92335 18.1729 3.99017 18.1038C4.05643 18.0353 4.14262 18 4.22877 18Z"
                                stroke="#FF5A5A"/>
                            <path
                                d="M4.22927 15.75H4.3054H4.22927ZM4.22927 15.75V15.25H4.28188L7.78325 14.9199C8.04995 14.892 8.3023 14.7701 8.49721 14.5705C8.49745 14.5702 8.4977 14.57 8.49795 14.5697L16.1038 6.70159C16.3078 6.47619 16.4206 6.17333 16.4127 5.85795C16.4047 5.54043 16.2754 5.2426 16.0583 5.02861L16.0497 5.02011L16.0498 5.02001L13.7381 2.62862C13.5247 2.42364 13.2493 2.30871 12.9644 2.30096C12.6834 2.29331 12.4069 2.39024 12.1854 2.57769L4.59022 10.4347C4.59002 10.435 4.58982 10.4352 4.58961 10.4354C4.39573 10.6379 4.27272 10.906 4.24484 11.1954L4.24468 11.1971L3.88129 14.8427C3.87654 14.8994 3.88386 14.9564 3.90239 15.0092C3.92107 15.0626 3.95041 15.1097 3.98723 15.1477M4.22927 15.75L4.22628 15.25C4.18317 15.2503 4.14002 15.2417 4.09916 15.2245C4.05843 15.2073 4.02024 15.1815 3.98723 15.1477M4.22927 15.75C4.11795 15.7507 4.0076 15.7286 3.90455 15.6851M4.22927 15.75L3.90455 15.6851M3.98723 15.1477C3.98709 15.1476 3.98695 15.1474 3.9868 15.1473L3.62873 15.4962M3.98723 15.1477C3.98734 15.1478 3.98746 15.148 3.98758 15.1481L3.62873 15.4962M3.62873 15.4962C3.70776 15.5773 3.8015 15.6415 3.90455 15.6851M3.62873 15.4962L3.90455 15.6851M13.2755 3.15249L12.9114 2.77586L12.5521 3.15706L10.9027 4.90706L10.5754 5.25437L10.9071 5.59751L13.1739 7.94251L13.5289 8.30972L13.8885 7.94703L15.5802 6.24078L15.9248 5.89318L15.5846 5.54124L13.2755 3.15249ZM5.02981 10.9475L4.90546 11.0752L4.88996 11.2528L4.66158 13.869L4.6093 14.468L5.20774 14.4102L7.74524 14.1652L7.92863 14.1475L8.05668 14.015L12.7933 9.11501L13.1293 8.7675L12.7933 8.41999L10.5096 6.05749L10.1514 5.68692L9.79185 6.05621L5.02981 10.9475Z"
                                stroke="#FF5A5A"/>
                          </svg>
                        </div>
                        <div class="btn-tree-parent" role="button" @click="DeleteCate(f)">
                          <svg fill="none" height="19" viewBox="0 0 19 18" width="19"
                               xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.8329 5.17243V5.67243H13.3329H17.4996C17.5824 5.67243 17.6654 5.70631 17.7294 5.77243C17.7938 5.83913 17.8329 5.9331 17.8329 6.03449C17.8329 6.13589 17.7938 6.22986 17.7294 6.29656C17.6654 6.36268 17.5824 6.39656 17.4996 6.39656H16.6663H16.1663V6.89656V16.3793C16.1663 16.938 15.9516 17.4705 15.5745 17.8605C15.1981 18.25 14.6911 18.4655 14.1663 18.4655H5.83293C5.30807 18.4655 4.80113 18.25 4.42465 17.8605C4.04762 17.4705 3.83293 16.938 3.83293 16.3793V6.89656V6.39656H3.33293H2.49959C2.41676 6.39656 2.33375 6.36268 2.26983 6.29656C2.20535 6.22986 2.16626 6.13589 2.16626 6.03449C2.16626 5.9331 2.20535 5.83913 2.26983 5.77243C2.33375 5.70631 2.41676 5.67243 2.49959 5.67243H6.66626H7.16626V5.17243V3.74221C7.1833 3.3204 7.36023 2.92588 7.65366 2.64297C7.94842 2.35878 8.33647 2.21003 8.73215 2.22385L8.74087 2.22415H8.74959H11.2496H11.2583L11.267 2.22385C11.6627 2.21003 12.0508 2.35878 12.3455 2.64297C12.639 2.92588 12.8159 3.32039 12.8329 3.7422V5.17243ZM11.6663 5.67243H12.1663V5.17243V3.73277C12.1663 3.45113 11.9964 3.24649 11.843 3.13467C11.6783 3.01473 11.4697 2.94829 11.2496 2.94829H8.74959C8.52953 2.94829 8.32087 3.01473 8.15622 3.13467C8.00274 3.24649 7.83293 3.45113 7.83293 3.73277V5.17243V5.67243H8.33293H11.6663ZM4.99959 6.39656H4.49959V6.89656V16.3793C4.49959 16.7352 4.63609 17.0798 4.88418 17.3364C5.13282 17.5936 5.47373 17.7414 5.83293 17.7414H14.1663C14.5255 17.7414 14.8664 17.5936 15.115 17.3364C15.3631 17.0798 15.4996 16.7352 15.4996 16.3793V6.89656V6.39656H14.9996H4.99959Z"
                                fill="#FF5A5A" stroke="#FF5A5A"/>
                            <path
                                d="M7.72935 14.0552C7.66543 14.1213 7.58242 14.1552 7.49959 14.1552C7.41676 14.1552 7.33375 14.1213 7.26983 14.0552C7.20535 13.9885 7.16626 13.8945 7.16626 13.7931V10.3448C7.16626 10.2434 7.20535 10.1495 7.26983 10.0828C7.33375 10.0166 7.41676 9.98276 7.49959 9.98276C7.58242 9.98276 7.66543 10.0166 7.72935 10.0828C7.79383 10.1495 7.83293 10.2434 7.83293 10.3448V13.7931C7.83293 13.8945 7.79383 13.9885 7.72935 14.0552Z"
                                fill="#FF5A5A" stroke="#FF5A5A"/>
                            <path
                                d="M12.7294 14.0552C12.6654 14.1213 12.5824 14.1552 12.4996 14.1552C12.4168 14.1552 12.3338 14.1213 12.2698 14.0552C12.2054 13.9885 12.1663 13.8945 12.1663 13.7931V10.3448C12.1663 10.2434 12.2054 10.1495 12.2698 10.0828C12.3338 10.0166 12.4168 9.98276 12.4996 9.98276C12.5824 9.98276 12.6654 10.0166 12.7294 10.0828C12.7938 10.1495 12.8329 10.2434 12.8329 10.3448V13.7931C12.8329 13.8945 12.7938 13.9885 12.7294 14.0552Z"
                                fill="#FF5A5A" stroke="#FF5A5A"/>
                          </svg>
                        </div>
                        <div class="btn-tree-parent" role="button" @click="sortCate(f)">
                          <svg id="Capa_1" fill="#ff0000" height="16px" stroke="#ff0000"
                               version="1.1" viewBox="0 0 411.98 411.98" width="16px"
                               xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                              <g>
                                <path
                                    d="M252.939,268.071c1.489,1.98,1.483,4.711-0.035,6.686L149.058,409.835c-1.046,1.354-2.663,2.146-4.374,2.146 c-1.703,0-3.325-0.792-4.371-2.146L36.473,274.744c-0.769-0.993-1.144-2.175-1.144-3.356c0-1.147,0.363-2.329,1.102-3.322 c1.501-1.969,4.129-2.707,6.434-1.809l68.757,27.166V5.5c0-3.044,2.477-5.5,5.515-5.5h55.109c3.038,0,5.503,2.456,5.503,5.5 v287.923l68.76-27.166C248.813,265.358,251.45,266.097,252.939,268.071z M318.798,121.452v103.495h28.176V89.953h-21.757 l-32.356,17.318l6.289,24.784L318.798,121.452z M376.651,306.036c0,32.816-12.513,51.832-23.016,62.004 c-10.138,9.941-24.087,16.385-39.26,18.116c-4.351,0.686-8.854,1.059-13.122,1.059c-1.129,0-2.181-0.03-3.162-0.077l-5.763-0.277 v-26.103l6.679,0.697c3.139,0.319,6.774-0.029,12.194-0.573c8.559-1.176,16.296-4.746,22.153-10.284 c3.907-3.541,7.081-7.832,9.511-12.833c-5.592,2.519-11.834,3.818-18.584,3.818c-24.541,0-42.351-18.37-42.351-43.68 c0-27.888,21.096-49.728,48.025-49.728C358.328,248.182,376.651,270.891,376.651,306.036z M347.725,303.956 c0-9.322-1.868-30.996-19.092-30.996c-10.687,0-18.146,9.787-18.146,23.82c0,12.17,6.903,20.037,17.578,20.037 c8.239,0,15.332-3.688,18.985-9.877C347.382,306.396,347.725,305.657,347.725,303.956z">
                                </path>
                              </g>
                            </g>
                          </svg>
                        </div>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-collapse :id="'collapse-' + f.id" v-model="f.isShow">
                    <b-row v-for="(v, stt2) in f.children" :key="stt2" class="tree-item-chi">
                      <b-col :class="v.id == item_active_id ? 'item-chi-active' : ''" class="div-item-text" md="8" sm="8"
                             xs="8">
                        <b-row>
                          <b-form-input v-if="v.editMode" v-model="v.name" placeholder="Nhập danh mục" type="text"/>
                          <label v-else class="tree-item-text-chi" @click="clickTreeItem(v)">{{ v.name }}
                          </label>
                        </b-row>
                      </b-col>
                      <b-col md="3" sm="3" xs="3">
                        <b-row v-if="v.editMode">
                          <div class="btn-tree" role="button" @click="cancelEditTopic(v)">
                            <svg fill="none" height="16" viewBox="0 0 16 16" width="16"
                                 xmlns="http://www.w3.org/2000/svg">
                              <circle cx="10" cy="10" fill="#FF5A5A" r="10"/>
                              <path
                                  d="M11.3222 10.0043L15.3534 5.53551C15.53 5.33936 15.6291 5.07333 15.6291 4.79593C15.6291 4.51853 15.53 4.2525 15.3534 4.05635C15.1769 3.8602 14.9375 3.75 14.6878 3.75C14.4382 3.75 14.1987 3.8602 14.0222 4.05635L10.0003 8.53551L5.97843 4.05635C5.8019 3.8602 5.56247 3.75 5.31281 3.75C5.06315 3.75 4.82372 3.8602 4.64718 4.05635C4.47065 4.2525 4.37147 4.51853 4.37147 4.79593C4.37147 5.07333 4.47065 5.33936 4.64718 5.53551L8.67843 10.0043L4.64718 14.473C4.55931 14.5698 4.48957 14.6851 4.44197 14.812C4.39438 14.9389 4.36987 15.0751 4.36987 15.2126C4.36987 15.3501 4.39438 15.4863 4.44197 15.6132C4.48957 15.7401 4.55931 15.8553 4.64718 15.9522C4.73434 16.0498 4.83803 16.1273 4.95227 16.1802C5.06651 16.2331 5.18905 16.2603 5.31281 16.2603C5.43657 16.2603 5.55911 16.2331 5.67335 16.1802C5.78759 16.1273 5.89128 16.0498 5.97843 15.9522L10.0003 11.473L14.0222 15.9522C14.1093 16.0498 14.213 16.1273 14.3273 16.1802C14.4415 16.2331 14.564 16.2603 14.6878 16.2603C14.8116 16.2603 14.9341 16.2331 15.0484 16.1802C15.1626 16.1273 15.2663 16.0498 15.3534 15.9522C15.4413 15.8553 15.511 15.7401 15.5586 15.6132C15.6062 15.4863 15.6307 15.3501 15.6307 15.2126C15.6307 15.0751 15.6062 14.9389 15.5586 14.812C15.511 14.6851 15.4413 14.5698 15.3534 14.473L11.3222 10.0043Z"
                                  fill="white"/>
                            </svg>
                          </div>
                          <div class="btn-tree" role="button" @click="saveEditCate(v)">
                            <svg fill="none" height="16" viewBox="0 0 16 16" width="16"
                                 xmlns="http://www.w3.org/2000/svg">
                              <circle cx="10" cy="10" fill="#6FC959" r="10"/>
                              <path
                                  d="M8.49491 16.25C8.38334 16.2495 8.27304 16.2197 8.17087 16.1624C8.06869 16.105 7.97681 16.0214 7.90095 15.9167L3.94662 10.5312C3.79881 10.3296 3.71962 10.061 3.72649 9.78456C3.73335 9.50814 3.82571 9.24653 3.98324 9.05729C4.14077 8.86805 4.35056 8.76667 4.56648 8.77546C4.78239 8.78425 4.98673 8.90249 5.13455 9.10416L8.48677 13.6771L15.3295 4.09375C15.399 3.98304 15.4854 3.89168 15.5834 3.82527C15.6814 3.75887 15.789 3.71881 15.8996 3.70758C16.0101 3.69635 16.1213 3.71417 16.2263 3.75995C16.3313 3.80573 16.4278 3.8785 16.51 3.9738C16.5923 4.06909 16.6584 4.1849 16.7044 4.31411C16.7503 4.44331 16.7752 4.58319 16.7774 4.72514C16.7796 4.8671 16.7592 5.00814 16.7173 5.13959C16.6754 5.27105 16.6129 5.39015 16.5337 5.48958L9.09701 15.9062C9.02186 16.0129 8.9303 16.0984 8.82809 16.1576C8.72587 16.2168 8.61521 16.2482 8.50304 16.25H8.49491Z"
                                  fill="white"/>
                            </svg>
                          </div>
                        </b-row>
                        <b-row v-else>
                          <div class="btn-tree" role="button" @click="editTopic(v)">
                            <svg fill="none" height="16" viewBox="0 0 16 16" width="16"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M4.22877 18H16.0704C16.1566 18 16.2428 18.0353 16.309 18.1038C16.3759 18.1729 16.4163 18.2702 16.4163 18.375C16.4163 18.4798 16.3759 18.5771 16.309 18.6462C16.2428 18.7148 16.1566 18.75 16.0704 18.75H4.22877C4.14262 18.75 4.05643 18.7148 3.99017 18.6462C3.92335 18.5771 3.88293 18.4798 3.88293 18.375C3.88293 18.2702 3.92335 18.1729 3.99017 18.1038C4.05643 18.0353 4.14262 18 4.22877 18Z"
                                  stroke="#FF5A5A"/>
                              <path
                                  d="M4.22927 15.75H4.3054H4.22927ZM4.22927 15.75V15.25H4.28188L7.78325 14.9199C8.04995 14.892 8.3023 14.7701 8.49721 14.5705C8.49745 14.5702 8.4977 14.57 8.49795 14.5697L16.1038 6.70159C16.3078 6.47619 16.4206 6.17333 16.4127 5.85795C16.4047 5.54043 16.2754 5.2426 16.0583 5.02861L16.0497 5.02011L16.0498 5.02001L13.7381 2.62862C13.5247 2.42364 13.2493 2.30871 12.9644 2.30096C12.6834 2.29331 12.4069 2.39024 12.1854 2.57769L4.59022 10.4347C4.59002 10.435 4.58982 10.4352 4.58961 10.4354C4.39573 10.6379 4.27272 10.906 4.24484 11.1954L4.24468 11.1971L3.88129 14.8427C3.87654 14.8994 3.88386 14.9564 3.90239 15.0092C3.92107 15.0626 3.95041 15.1097 3.98723 15.1477M4.22927 15.75L4.22628 15.25C4.18317 15.2503 4.14002 15.2417 4.09916 15.2245C4.05843 15.2073 4.02024 15.1815 3.98723 15.1477M4.22927 15.75C4.11795 15.7507 4.0076 15.7286 3.90455 15.6851M4.22927 15.75L3.90455 15.6851M3.98723 15.1477C3.98709 15.1476 3.98695 15.1474 3.9868 15.1473L3.62873 15.4962M3.98723 15.1477C3.98734 15.1478 3.98746 15.148 3.98758 15.1481L3.62873 15.4962M3.62873 15.4962C3.70776 15.5773 3.8015 15.6415 3.90455 15.6851M3.62873 15.4962L3.90455 15.6851M13.2755 3.15249L12.9114 2.77586L12.5521 3.15706L10.9027 4.90706L10.5754 5.25437L10.9071 5.59751L13.1739 7.94251L13.5289 8.30972L13.8885 7.94703L15.5802 6.24078L15.9248 5.89318L15.5846 5.54124L13.2755 3.15249ZM5.02981 10.9475L4.90546 11.0752L4.88996 11.2528L4.66158 13.869L4.6093 14.468L5.20774 14.4102L7.74524 14.1652L7.92863 14.1475L8.05668 14.015L12.7933 9.11501L13.1293 8.7675L12.7933 8.41999L10.5096 6.05749L10.1514 5.68692L9.79185 6.05621L5.02981 10.9475Z"
                                  stroke="#FF5A5A"/>
                            </svg>
                          </div>
                          <div class="btn-tree" role="button" @click="DeleteCate(v)">
                            <svg fill="none" height="16" viewBox="0 0 16 16" width="16"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M12.8329 5.17243V5.67243H13.3329H17.4996C17.5824 5.67243 17.6654 5.70631 17.7294 5.77243C17.7938 5.83913 17.8329 5.9331 17.8329 6.03449C17.8329 6.13589 17.7938 6.22986 17.7294 6.29656C17.6654 6.36268 17.5824 6.39656 17.4996 6.39656H16.6663H16.1663V6.89656V16.3793C16.1663 16.938 15.9516 17.4705 15.5745 17.8605C15.1981 18.25 14.6911 18.4655 14.1663 18.4655H5.83293C5.30807 18.4655 4.80113 18.25 4.42465 17.8605C4.04762 17.4705 3.83293 16.938 3.83293 16.3793V6.89656V6.39656H3.33293H2.49959C2.41676 6.39656 2.33375 6.36268 2.26983 6.29656C2.20535 6.22986 2.16626 6.13589 2.16626 6.03449C2.16626 5.9331 2.20535 5.83913 2.26983 5.77243C2.33375 5.70631 2.41676 5.67243 2.49959 5.67243H6.66626H7.16626V5.17243V3.74221C7.1833 3.3204 7.36023 2.92588 7.65366 2.64297C7.94842 2.35878 8.33647 2.21003 8.73215 2.22385L8.74087 2.22415H8.74959H11.2496H11.2583L11.267 2.22385C11.6627 2.21003 12.0508 2.35878 12.3455 2.64297C12.639 2.92588 12.8159 3.32039 12.8329 3.7422V5.17243ZM11.6663 5.67243H12.1663V5.17243V3.73277C12.1663 3.45113 11.9964 3.24649 11.843 3.13467C11.6783 3.01473 11.4697 2.94829 11.2496 2.94829H8.74959C8.52953 2.94829 8.32087 3.01473 8.15622 3.13467C8.00274 3.24649 7.83293 3.45113 7.83293 3.73277V5.17243V5.67243H8.33293H11.6663ZM4.99959 6.39656H4.49959V6.89656V16.3793C4.49959 16.7352 4.63609 17.0798 4.88418 17.3364C5.13282 17.5936 5.47373 17.7414 5.83293 17.7414H14.1663C14.5255 17.7414 14.8664 17.5936 15.115 17.3364C15.3631 17.0798 15.4996 16.7352 15.4996 16.3793V6.89656V6.39656H14.9996H4.99959Z"
                                  fill="#FF5A5A" stroke="#FF5A5A"/>
                              <path
                                  d="M7.72935 14.0552C7.66543 14.1213 7.58242 14.1552 7.49959 14.1552C7.41676 14.1552 7.33375 14.1213 7.26983 14.0552C7.20535 13.9885 7.16626 13.8945 7.16626 13.7931V10.3448C7.16626 10.2434 7.20535 10.1495 7.26983 10.0828C7.33375 10.0166 7.41676 9.98276 7.49959 9.98276C7.58242 9.98276 7.66543 10.0166 7.72935 10.0828C7.79383 10.1495 7.83293 10.2434 7.83293 10.3448V13.7931C7.83293 13.8945 7.79383 13.9885 7.72935 14.0552Z"
                                  fill="#FF5A5A" stroke="#FF5A5A"/>
                              <path
                                  d="M12.7294 14.0552C12.6654 14.1213 12.5824 14.1552 12.4996 14.1552C12.4168 14.1552 12.3338 14.1213 12.2698 14.0552C12.2054 13.9885 12.1663 13.8945 12.1663 13.7931V10.3448C12.1663 10.2434 12.2054 10.1495 12.2698 10.0828C12.3338 10.0166 12.4168 9.98276 12.4996 9.98276C12.5824 9.98276 12.6654 10.0166 12.7294 10.0828C12.7938 10.1495 12.8329 10.2434 12.8329 10.3448V13.7931C12.8329 13.8945 12.7938 13.9885 12.7294 14.0552Z"
                                  fill="#FF5A5A" stroke="#FF5A5A"/>
                            </svg>
                          </div>
                          <div class="btn-tree" role="button" @click="sortCate(v)">
                            <svg id="Capa_1" fill="#ff0000" height="16px" stroke="#ff0000"
                                 version="1.1" viewBox="0 0 411.98 411.98" width="16px"
                                 xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                              <g id="SVGRepo_iconCarrier">
                                <g>
                                  <path
                                      d="M252.939,268.071c1.489,1.98,1.483,4.711-0.035,6.686L149.058,409.835c-1.046,1.354-2.663,2.146-4.374,2.146 c-1.703,0-3.325-0.792-4.371-2.146L36.473,274.744c-0.769-0.993-1.144-2.175-1.144-3.356c0-1.147,0.363-2.329,1.102-3.322 c1.501-1.969,4.129-2.707,6.434-1.809l68.757,27.166V5.5c0-3.044,2.477-5.5,5.515-5.5h55.109c3.038,0,5.503,2.456,5.503,5.5 v287.923l68.76-27.166C248.813,265.358,251.45,266.097,252.939,268.071z M318.798,121.452v103.495h28.176V89.953h-21.757 l-32.356,17.318l6.289,24.784L318.798,121.452z M376.651,306.036c0,32.816-12.513,51.832-23.016,62.004 c-10.138,9.941-24.087,16.385-39.26,18.116c-4.351,0.686-8.854,1.059-13.122,1.059c-1.129,0-2.181-0.03-3.162-0.077l-5.763-0.277 v-26.103l6.679,0.697c3.139,0.319,6.774-0.029,12.194-0.573c8.559-1.176,16.296-4.746,22.153-10.284 c3.907-3.541,7.081-7.832,9.511-12.833c-5.592,2.519-11.834,3.818-18.584,3.818c-24.541,0-42.351-18.37-42.351-43.68 c0-27.888,21.096-49.728,48.025-49.728C358.328,248.182,376.651,270.891,376.651,306.036z M347.725,303.956 c0-9.322-1.868-30.996-19.092-30.996c-10.687,0-18.146,9.787-18.146,23.82c0,12.17,6.903,20.037,17.578,20.037 c8.239,0,15.332-3.688,18.985-9.877C347.382,306.396,347.725,305.657,347.725,303.956z">
                                  </path>
                                </g>
                              </g>
                            </svg>
                          </div>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <!-- <b-col md="1" sm="1" xs="1"></b-col> -->
                      <b-col class="ml-50" md="8" sm="8" xs="8">
                        <b-button class="btn-sm ml-50 mt-1 btn-add-item" @click="AddNewTopic(f)">
                          <svg fill="none" height="8" viewBox="0 0 8 8" width="8" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3.72705 7.10498V3.9375H0.565918V3.41699H3.72705V0.262207H4.23486V3.41699H7.40869V3.9375H4.23486V7.10498H3.72705Z"
                                fill="black"/>
                          </svg>
                          Thêm
                        </b-button>
                      </b-col>
                      <b-col md="3" sm="3" xs="3">

                      </b-col>
                    </b-row>
                  </b-collapse>
                </span>
            <!-- button thêm mới menu cha -->
            <span>
                  <b-row>
                    <b-col class="mt-1" md="12"></b-col>
                    <b-col md="9" sm="9" xs="9">
                      <b-button class="btn-sm mr-50 btn-add-item" @click="AddNewCate()">
                        <svg fill="none" height="8" viewBox="0 0 8 8" width="8" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M3.72705 7.10498V3.9375H0.565918V3.41699H3.72705V0.262207H4.23486V3.41699H7.40869V3.9375H4.23486V7.10498H3.72705Z"
                              fill="black"/>
                        </svg>
                        Thêm
                      </b-button>
                    </b-col>
                    <b-col md="3" sm="3" xs="3">
                    </b-col>
                  </b-row>
                </span>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col class="use-new" md="8" sm="6" xs="12">
        <b-card v-if="currentItem != null" class="text-left" no-body>
          <b-card-body>
            <b-row>
              <b-col md="12" sm="12" xs="12">
                <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :pagination-options="{ perPage: serverParams.pageSize, enabled: true, perPageDropdown: [50, 100], dropdownAllowAll: false }"
                                :rows="listHonors"
                                :totalRows="totalRecordHot" max-height="720px" mode="remote"
                                styleClass="vgt-table striped"
                                @on-page-change="onPageChange"
                                @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange">
                  <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'before'">
                  <span class="btn-row" @click="editRow(props.row)"><svg fill="none" height="25" viewBox="0 0 25 25"
                                                                         width="25" xmlns="http://www.w3.org/2000/svg"><path
                      d="M4.22877 18H16.0704C16.1566 18 16.2428 18.0353 16.309 18.1038C16.3759 18.1729 16.4163 18.2702 16.4163 18.375C16.4163 18.4798 16.3759 18.5771 16.309 18.6462C16.2428 18.7148 16.1566 18.75 16.0704 18.75H4.22877C4.14262 18.75 4.05643 18.7148 3.99017 18.6462C3.92335 18.5771 3.88293 18.4798 3.88293 18.375C3.88293 18.2702 3.92335 18.1729 3.99017 18.1038C4.05643 18.0353 4.14262 18 4.22877 18Z"
                      stroke="#FF5A5A"></path><path
                      d="M4.22927 15.75H4.3054H4.22927ZM4.22927 15.75V15.25H4.28188L7.78325 14.9199C8.04995 14.892 8.3023 14.7701 8.49721 14.5705C8.49745 14.5702 8.4977 14.57 8.49795 14.5697L16.1038 6.70159C16.3078 6.47619 16.4206 6.17333 16.4127 5.85795C16.4047 5.54043 16.2754 5.2426 16.0583 5.02861L16.0497 5.02011L16.0498 5.02001L13.7381 2.62862C13.5247 2.42364 13.2493 2.30871 12.9644 2.30096C12.6834 2.29331 12.4069 2.39024 12.1854 2.57769L4.59022 10.4347C4.59002 10.435 4.58982 10.4352 4.58961 10.4354C4.39573 10.6379 4.27272 10.906 4.24484 11.1954L4.24468 11.1971L3.88129 14.8427C3.87654 14.8994 3.88386 14.9564 3.90239 15.0092C3.92107 15.0626 3.95041 15.1097 3.98723 15.1477M4.22927 15.75L4.22628 15.25C4.18317 15.2503 4.14002 15.2417 4.09916 15.2245C4.05843 15.2073 4.02024 15.1815 3.98723 15.1477M4.22927 15.75C4.11795 15.7507 4.0076 15.7286 3.90455 15.6851M4.22927 15.75L3.90455 15.6851M3.98723 15.1477C3.98709 15.1476 3.98695 15.1474 3.9868 15.1473L3.62873 15.4962M3.98723 15.1477C3.98734 15.1478 3.98746 15.148 3.98758 15.1481L3.62873 15.4962M3.62873 15.4962C3.70776 15.5773 3.8015 15.6415 3.90455 15.6851M3.62873 15.4962L3.90455 15.6851M13.2755 3.15249L12.9114 2.77586L12.5521 3.15706L10.9027 4.90706L10.5754 5.25437L10.9071 5.59751L13.1739 7.94251L13.5289 8.30972L13.8885 7.94703L15.5802 6.24078L15.9248 5.89318L15.5846 5.54124L13.2755 3.15249ZM5.02981 10.9475L4.90546 11.0752L4.88996 11.2528L4.66158 13.869L4.6093 14.468L5.20774 14.4102L7.74524 14.1652L7.92863 14.1475L8.05668 14.015L12.7933 9.11501L13.1293 8.7675L12.7933 8.41999L10.5096 6.05749L10.1514 5.68692L9.79185 6.05621L5.02981 10.9475Z"
                      stroke="#FF5A5A"></path></svg></span>
                  <span class="btn-row" @click="deleteRow(props.row)"><svg fill="none" height="25" viewBox="0 0 25 25"
                                                                           width="25"
                                                                           xmlns="http://www.w3.org/2000/svg"><path
                      d="M12.8329 5.17243V5.67243H13.3329H17.4996C17.5824 5.67243 17.6654 5.70631 17.7294 5.77243C17.7938 5.83913 17.8329 5.9331 17.8329 6.03449C17.8329 6.13589 17.7938 6.22986 17.7294 6.29656C17.6654 6.36268 17.5824 6.39656 17.4996 6.39656H16.6663H16.1663V6.89656V16.3793C16.1663 16.938 15.9516 17.4705 15.5745 17.8605C15.1981 18.25 14.6911 18.4655 14.1663 18.4655H5.83293C5.30807 18.4655 4.80113 18.25 4.42465 17.8605C4.04762 17.4705 3.83293 16.938 3.83293 16.3793V6.89656V6.39656H3.33293H2.49959C2.41676 6.39656 2.33375 6.36268 2.26983 6.29656C2.20535 6.22986 2.16626 6.13589 2.16626 6.03449C2.16626 5.9331 2.20535 5.83913 2.26983 5.77243C2.33375 5.70631 2.41676 5.67243 2.49959 5.67243H6.66626H7.16626V5.17243V3.74221C7.1833 3.3204 7.36023 2.92588 7.65366 2.64297C7.94842 2.35878 8.33647 2.21003 8.73215 2.22385L8.74087 2.22415H8.74959H11.2496H11.2583L11.267 2.22385C11.6627 2.21003 12.0508 2.35878 12.3455 2.64297C12.639 2.92588 12.8159 3.32039 12.8329 3.7422V5.17243ZM11.6663 5.67243H12.1663V5.17243V3.73277C12.1663 3.45113 11.9964 3.24649 11.843 3.13467C11.6783 3.01473 11.4697 2.94829 11.2496 2.94829H8.74959C8.52953 2.94829 8.32087 3.01473 8.15622 3.13467C8.00274 3.24649 7.83293 3.45113 7.83293 3.73277V5.17243V5.67243H8.33293H11.6663ZM4.99959 6.39656H4.49959V6.89656V16.3793C4.49959 16.7352 4.63609 17.0798 4.88418 17.3364C5.13282 17.5936 5.47373 17.7414 5.83293 17.7414H14.1663C14.5255 17.7414 14.8664 17.5936 15.115 17.3364C15.3631 17.0798 15.4996 16.7352 15.4996 16.3793V6.89656V6.39656H14.9996H4.99959Z"
                      fill="#FF5A5A" stroke="#FF5A5A"></path><path
                      d="M7.72935 14.0552C7.66543 14.1213 7.58242 14.1552 7.49959 14.1552C7.41676 14.1552 7.33375 14.1213 7.26983 14.0552C7.20535 13.9885 7.16626 13.8945 7.16626 13.7931V10.3448C7.16626 10.2434 7.20535 10.1495 7.26983 10.0828C7.33375 10.0166 7.41676 9.98276 7.49959 9.98276C7.58242 9.98276 7.66543 10.0166 7.72935 10.0828C7.79383 10.1495 7.83293 10.2434 7.83293 10.3448V13.7931C7.83293 13.8945 7.79383 13.9885 7.72935 14.0552Z"
                      fill="#FF5A5A" stroke="#FF5A5A"></path><path
                      d="M12.7294 14.0552C12.6654 14.1213 12.5824 14.1552 12.4996 14.1552C12.4168 14.1552 12.3338 14.1213 12.2698 14.0552C12.2054 13.9885 12.1663 13.8945 12.1663 13.7931V10.3448C12.1663 10.2434 12.2054 10.1495 12.2698 10.0828C12.3338 10.0166 12.4168 9.98276 12.4996 9.98276C12.5824 9.98276 12.6654 10.0166 12.7294 10.0828C12.7938 10.1495 12.8329 10.2434 12.8329 10.3448V13.7931C12.8329 13.8945 12.7938 13.9885 12.7294 14.0552Z"
                      fill="#FF5A5A" stroke="#FF5A5A"></path></svg></span>
                </span>
                    <span v-else-if="props.column.field == 'image_path'">
                    <img :src="props.row.image_path" style="max-height: 60px;width:auto"/>

                  </span>
                    <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="12" sm="12" xs="12">&nbsp;</b-col>
            </b-row>
            <b-row class="text-center">
              <b-col class="text-left" md="6" sm="6" xs="6">
                <b-button class="btn-sm btn-save" variant="primary" @click="addNews()">Thêm mới</b-button>
              </b-col>
              <!-- <b-col md="6" sm="6" xs="6" class="text-right">
                <b-button variant="primary" @click="saveNews(currentItem)"
                  class="btn-sm btn-save">Lưu</b-button>
              </b-col> -->
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal id="modal-confirm-delete" centered hide-footer hide-header no-close-on-backdrop no-close-on-esc title="">
      <div>
        <b-row>
          <b-col>
            <label class="text-confirm-delete">Bạn có chắc chắn muốn xóa danh mục</label>
          </b-col>
        </b-row>
        <div class="mt-50">&nbsp;</div>
        <b-row class="mt-50 bottom-delete">
          <b-col class="text-center" md="6" sm="6" xs="6">
            <b-button class="btn-sm mr-50 btn-back" variant="primary" @click="closeModal('modal-confirm-delete')">Quay
              lại
            </b-button>
          </b-col>
          <b-col class="text-center" md="6" sm="6" xs="6">
            <b-button class="btn-sm mr-50 btn-delete" variant="primary" @click="deleteConfirm()">XÓA</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal id="modal-confirm-delete-new" centered hide-footer hide-header no-close-on-backdrop no-close-on-esc
             title="">
      <div>
        <b-row>
          <b-col>
            <label class="text-confirm-delete">Bạn có chắc chắn muốn xóa chủ đề này không</label>
          </b-col>
        </b-row>
        <div class="mt-50">&nbsp;</div>
        <b-row class="mt-50 bottom-delete">
          <b-col class="text-center" md="6" sm="6" xs="6">
            <b-button class="btn-sm mr-50 btn-back" variant="primary"
                      @click="closeModal('modal-confirm-delete-new')">Quay
              lại
            </b-button>
          </b-col>
          <b-col class="text-center" md="6" sm="6" xs="6">
            <b-button class="btn-sm mr-50 btn-delete" variant="primary" @click="deletesNewConfirm()">XÓA</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal id="modal-confirm-sucess" centered hide-footer hide-header no-close-on-backdrop no-close-on-esc title="">
      <div>
        <b-row>
          <b-col>
            <label class="text-confirm-delete">LƯU THÀNH CÔNG</label>
          </b-col>
        </b-row>
        <div class="mt-50">&nbsp;</div>
        <b-row class="mt-50 bottom-delete">
          <b-col class="text-center" md="6" sm="6" xs="6">
            <b-button class="btn-sm mr-50 btn-back" variant="primary"
                      @click="closeModal('modal-confirm-delete')">ĐÓNG
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal id="modal-sort-cat" centered hide-footer hide-header no-close-on-backdrop no-close-on-esc title="">
      <div>
        <b-row>
          <b-col md="4" sm="4" xs="6">
            <label class="tree-item-text">Nhập thứ tự</label>
          </b-col>
          <b-col md="8" sm="8" xs="12">
            <b-form-input v-model="currentItem.sort_order" placeholder="Số thự tự" type="number"/>
          </b-col>
        </b-row>
        <div class="mt-50">&nbsp;</div>
        <b-row class="mt-50 bottom-delete">
          <b-col class="text-center" md="6" sm="6" xs="6">
            <b-button class="btn-sm mr-50 btn-back" variant="primary" @click="closeModal('modal-sort-cat')">Quay
              lại
            </b-button>
          </b-col>
          <b-col class="text-center" md="6" sm="6" xs="6">
            <b-button class="btn-sm mr-50 btn-delete" variant="primary"
                      @click="saveEditCate(currentItem)">Lưu
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal id="modal-honor-detail" :title="getTitle()" size="xl" @ok="handleOk">
      <b-row>
        <b-col cols="6">
          <b-form-group label="Danh mục">
            <b-form-input v-model="currentItem.cate_name" placeholder="Danh mục" readOnly="true" type="text"/>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group>
            <label>Trạng thái<span class='text-danger'>*</span></label>
            <Select2 v-model="currentItem.status" :options="statusList" :state="validateState('status')"
                     required/>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <label>Họ tên<span class='text-danger'>*</span></label>
            <b-form-input v-model="currentItem.full_name" :state="validateState('full_name')" placeholder="Họ tên" required
                          type="text"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group>
            <label>Loại giải<span class='text-danger'>*</span></label>
            <b-form-input v-model="currentItem.type_prize" :state="validateState('type_prize')" placeholder="Loại giải" required
                          type="text"/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group>
            <label>Kênh<span class='text-danger'>*</span></label>
            <b-form-input v-model="currentItem.channel" :state="validateState('channel')" placeholder="Kênh" required
                          type="text"/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group>
            <label>Điểm</label>
            <b-form-input v-model="currentItem.point" placeholder="Điểm" type="number"/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group>
            <label>Đối tác</label>
            <b-form-input v-model="currentItem.parner" placeholder="Đối tác" type="text"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-50 text-left" cols="12">
          <b-form-group>
            <label>Chọn ảnh đại diện</label>
            <div v-if="currentItem && currentItem.image_path">
              <img :src="currentItem.image_path?currentItem.image_path:'/img/6-small.c9b47a98.png'"
                   style="width:100%; max-width: 120px;height: 80px;"/>
              <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger" @click="removeFile()">
                <feather-icon icon="TrashIcon"/>
              </b-button>
            </div>
            <div class="clearfix mb-0 mt-50"></div>
            <b-form-file v-model="currentItem.file" accept="image/*" class="mrt-10" plain v-on:input="uploadFile">
            </b-form-file>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BForm,
  BInputGroup,
  BFormInput,
  BCardText,
  BInputGroupPrepend,
  BTabs,
  BTab,
  BListGroup,
  BListGroupItem,
  BFormGroup,
  BFormFile,
  BButton,
  BFormTextarea,
  BFormCheckbox, BCollapse, VBToggle
} from "bootstrap-vue";

import {
  DxHtmlEditor,
  DxTableContextMenu,
  DxTableResizing,
  DxMediaResizing,
  DxImageUpload
} from 'devextreme-vue/html-editor';

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import {getuserName} from '@/@core/utils/utils';
import {VueGoodTable} from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import moment from "moment";
import Select2 from "v-select2-component";
import Vue from 'vue';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxSelection,
  DxToolbar,
  DxItem,
  DxButton
} from 'devextreme-vue/data-grid';
import {DxFileUploader} from 'devextreme-vue/file-uploader';
import {$ctx} from '@themeConfig';

Vue.directive('b-toggle', VBToggle)

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BTabs,
    BTab,
    BTab,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    VueGoodTable,
    BFormFile,
    BButton,
    BFormTextarea,
    BCollapse,
    BFormCheckbox,
    Select2,
    DxHtmlEditor,
    DxTableContextMenu,
    DxTableResizing,
    DxMediaResizing,
    DxDataGrid,
    DxImageUpload,
    DxToolbar,
    DxItem,
    DxSelection,
    DxColumn,
    DxEditing,
    DxPaging,
    DxButton,
    DxFileUploader
  },
  data() {
    return {
      tabActive: 1,
      searchQuery: '',
      categoryList: [],
      searchHot: "",
      listHonors: [],
      currentItem: {},
      selected: 0,
      modal_title: "",
      totalRecords: 0,
      totalRecordHot: 0,
      isLoading: false,
      item_active_id: -1,
      topicSelected: {},
      urlApi: '',
      statusList: [
        {id: 1, text: "Hiệu lực"},
        {id: 0, text: "Hết hiệu lực"}
      ],
      options: {
        fields: [
          {
            field: "before",
            filterOptions: {enabled: false},
            label: ""
          },
          {
            field: "type_prize",
            filterOptions: {enabled: false},
            label: "Loại giải"
          },
          {
            field: "full_name",
            filterOptions: {enabled: false},
            label: "Họ và tên"
          },
          {
            field: "image_path",
            filterOptions: {enabled: false},
            label: "Ảnh đại diện"
          },
          {
            field: "channel",
            filterOptions: {enabled: false},
            label: "Kênh"
          },
          {
            field: "point",
            filterOptions: {enabled: false},
            label: "Số điểm"
          },
          {
            field: "parner",
            filterOptions: {enabled: false},
            label: "Đối tác"
          }
        ]
      },
      serverParams: {
        "columnFilters": {},
        "sort": [
          {"field": "created_date", "type": "desc"}
        ],
        "page": 1,
        "pageSize": 20,
        "lang": 1
      },
      sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
      fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
      headerValues: [false, 1, 2, 3, 4, 5]
    }
  },
  computed: {},
  mounted() {
    this.isSubmit = false;
    this.loadCategories();
    this.urlApi = $ctx.API_URL.replaceAll('api/tool/', 'upload_portal/');
  },
  created() {
  },

  methods: {
    validateState(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItem[pro]) return false;
      else return true;
      return null;
    },

    getTitle() {
      return this.modal_title;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.fetchNews();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.fetchNews();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.fetchNews();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      this.fetchNews();
    },

    quickSearch() {
      this.fetchNews();
    },

    fetchNews() {
      try {
        this.serverParams.columnFilters.topicId = this.item_active_id;
        this.serverParams.columnFilters.searchQuick = this.searchQuery;
        this.loading(true);
        useJwt.post("portal/gethonors", this.serverParams)
            .then((response) => {
              if (response.data.code == 200) {
                this.listHonors = response.data.result;
                this.totalRecordHot = response.data.totalRecords;
              } else {
                this.listHonors = [];
                this.totalRecordHot = 0;
              }
              this.isLoading = false;
              this.loading(false);
            })
            .catch((err) => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response?.data?.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            });
      } catch (err) {
        this.loading(false);
      }
    },

    async loadCategories() {
      this.categoryList = [];
      useJwt.get("portal/getAllCategoriesNew?cateType=1").then((response) => {
        var result = response.data;
        if (result.code == 200) {
          const listChildren = [];
          const self = this;
          result.result.forEach(item => {
            item.text = item.name;
            item.isShow = false;
            if (item.level == 0) {
              self.categoryList.push(item);
            } else {
              listChildren.push(item);
            }
          });
          self.categoryList.forEach(item => {
            item.children = listChildren.filter(function (chi) {
              return chi.parent_id == item.id
            });
          });
        }
        this.isLoading = false;
        this.loading(false);
      });
    },

    detailClick(row) {
      this.currentItem = row;
      const id = row.id;
      this.loading(true);
      useJwt
          .get("portal/honors/" + id)
          .then((response) => {
            if (response.data.code == 200) {
              this.currentItem = response.data.result;
            }
            this.loading(false);
          })
          .catch((err) => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.message,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },

    isSelected: function (i) {
      return this.currentItem && this.currentItem.id === i;
    },

    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },

    formatDate(v) {
      return moment(v, 'YYYY/MM/DD').format('DD/MM/YYYY')
    },

    /**
     *
     */
    async uploadFile() {
      try {
        this.loading(true);
        var formData = new FormData();
        formData.append("file", this.currentItem.file);
        const res = await useJwt.post(`portal/upload`, formData);
        if (res.data.code == 200) {
          this.currentItem.image_path = this.urlApi + res.data.result;
          console.log(this.currentItem);
        }
        this.loading(false);
      } catch (err) {
        this.loading(false);
      }

    },

    removeFile() {
      this.currentItem.image_path = '';
      this.currentItem.file = '';
    },

    /**
     *
     * @param {*} filePath
     */
    async downloadFile(filePath) {
      try {
        const downloadParams = {filePath: filePath};
        const arrFile = filePath.replaceAll('\\', '/').split('/');
        this.loading(true);
        const res = await useJwt.postDownload("portal/download", arrFile[1], downloadParams);
        this.loading(false);
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    },

    /**
     *
     */
    async clickTreeItem(topic) {
      this.topicSelected = topic;
      if (this.item_active_id == topic.id) {
        this.item_active_id = -1;
      } else {
        this.item_active_id = topic.id;
      }
      this.fetchNews();
    },

    /**
     *
     * @param {*} item
     */
    async isValid(item) {
      if (!item.name) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tên không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    },

    /**
     *
     * @param {*} item
     */
    editNewCate(item) {
      var catTemp = Object.assign([], this.categoryList);
      var oItem = catTemp.find(x => x.id == item.id);
      if (oItem) {
        oItem.editMode = true;
      }
      this.categoryList = catTemp;
    },

    /**
     *
     * @param {*} node
     */
    async editTopic(node) {
      var catTemp = Object.assign([], this.categoryList);
      var oItem = {};
      for (var i = 0; i < catTemp.length; i++) {
        var it = catTemp[i];
        var children = [];
        if (it && it.children) {
          children = it.children.filter(x => x.id == node.id);
        }
        if (children.length > 0) {
          break;
        }
      }
      oItem = children[0];
      if (oItem && Object.keys(oItem).length > 0) {
        oItem.editMode = true;
      }
      this.categoryList = catTemp;
    },

    /**
     *
     * @param {*} node
     */
    async cancelEditTopic(node) {
      var catTemp = Object.assign([], this.categoryList);
      var oItem = {};
      for (var i = 0; i < catTemp.length; i++) {
        var it = catTemp[i];
        var children = [];
        if (it && it.children) {
          children = it.children.filter(x => x.id == node.id);
        }
        if (children.length > 0) {
          break;
        }
      }
      oItem = children[0];
      if (oItem && Object.keys(oItem).length > 0) {
        oItem.editMode = false;
      }
      this.categoryList = catTemp;
    },

    /**
     *
     * @param {*} node
     */
    cancelEditCate(node) {
      var catTemp = Object.assign([], this.categoryList);
      var oItem = catTemp.find(x => x.id == node.id);
      if (oItem && Object.keys(oItem).length > 0) {
        oItem.editMode = false;
      } else {
        this.cancelEditTopic(node);
      }
      this.categoryList = catTemp;
    },

    async sortCate(item) {
      this.currentItem = item;
      this.$bvModal.show('modal-sort-cat');
    },

    /**
     *
     * @param {*} item
     */
    async DeleteCate(item) {
      this.currentItem = item;
      this.$bvModal.show('modal-confirm-delete');
    },
    async deleteConfirm() {
      var item = this.currentItem;
      const url = `portal/categories_new/${item.id}`;
      this.$bvModal.hide('modal-confirm-delete');
      try {
        this.loading(true);
        let res = await useJwt.delete(url);
        this.loading(false);
        if (res.data.code == 200) {
          this.loadCategories();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Xoá danh mục thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi xoá danh mục ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    /**
     *
     * @param {*} item
     */
    async saveEditCate(item) {
      const userName = getuserName();
      this.isSubmit = true;
      const bIsValid = await this.isValid(item);
      if (!bIsValid) {
        return;
      }
      if (item.id) {
        const url = `portal/categories_new/${item.id}`;
        const updateParams = {
          id: item.id,
          name: item.name,
          status: 1,
          parent_id: item.parent_id,
          sort_order: item.sort_order,
          description: item.description,
          level: item.level,
          created_at: userName,
          updated_at: userName,
          cat_type: 1
        };
        try {
          this.loading(true);
          const res = await useJwt.put(url, updateParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.loadCategories();
            this.$bvModal.hide('modal-sort-cat');
            return this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật danh mục thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
            return;
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi cập nhật danh mục ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        const createParams = {
          id: 0,
          name: item.name,
          status: 1,
          parent_id: item.parent_id,
          sort_order: item.sort_order,
          description: item.description,
          level: item.level,
          updated_at: userName,
          created_at: userName,
          cat_type: 1
        };
        this.loading(true);
        const res = await useJwt.post("portal/categories_new", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.isSubmit = false;
          this.loadCategories();
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới danh mục thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới danh mục ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async AddNewCate() {
      this.categoryList.push({id: 0, name: '', sort_order: 1, editMode: true, level: 0, status: 1, cat_type: 1});
    },
    /**
     *
     * @param {*} node
     */
    async AddNewTopic(node) {
      var catTemp = Object.assign([], this.categoryList);
      var oItem = catTemp.find(x => x.id == node.id);
      var newChi = {
        id: 0, name: '', editMode: true, level: node.level + 1, parent_id: node.id, status: 1,
        cat_type: 1
      };
      if (oItem.children) {
        oItem.children.push(newChi);
      } else {
        oItem.children = [newChi];
      }
      this.categoryList = catTemp;
    },
    // AddNewSub() {
    //   const userName = getuserName();
    //   this.listNews.push({ id: 0, name: '',sort_order:1, editMode: true, category_id: this.topicSelected.parent_id, topic_id: this.topicSelected.id, created_at: userName, status: 1,cat_type:1 });
    // },
    async closeModal(id) {
      this.$bvModal.hide(id);
    },
    /**
     *
     */
    addNews() {
      if (!this.item_active_id || this.item_active_id <= 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải chọn chủ đề!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return;
      }
      let topics = [];
      this.currentItem = {cate_id: this.item_active_id, status: 1};
      this.categoryList.forEach(function (item) {
        topics = topics.concat(item.children);
      });
      var oTopic = topics.find(x => x.id == this.item_active_id);
      var oCate = this.categoryList.find(x => x.id == oTopic.parent_id);

      if (oCate) {
        this.currentItem.cate_name = oCate.name + " > " + oTopic.name;
      }

      this.editMode = false;
      this.modal_title = "Thêm mới Vinh danh";
      this.$bvModal.show("modal-honor-detail");
    },
    /**
     *
     */
    async editRow(item) {
      this.currentItem = item;
      if (this.currentItem) {
        this.currentItem.editMode = true;
      }
      let topics = [];
      this.categoryList.forEach(function (item) {
        topics = topics.concat(item.children);
      });
      var oTopic = topics.find(x => x.id == this.item_active_id);
      var oCate = this.categoryList.find(x => x.id == oTopic.parent_id);

      if (oCate) {
        this.currentItem.cate_name = oCate.name + " > " + oTopic.name;
      }
      this.modal_title = "Sửa Vinh danh " + this.currentItem.full_name;
      this.$bvModal.show("modal-honor-detail");
    },


    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      const userName = getuserName();
      this.isSubmit = true;
      const bIsValid = await this.isValidPo(this.currentItem);
      if (!bIsValid) {
        return;
      }

      if (this.currentItem.id) {
        const url = `portal/honors/${this.currentItem.id}`;
        const updateParams = {
          id: this.currentItem.id,
          cate_id: this.currentItem.cate_id,
          full_name: this.currentItem.full_name,
          status: this.currentItem.status,
          type_prize: this.currentItem.type_prize,
          image_path: this.currentItem.image_path,
          channel: this.currentItem.channel,
          point: this.currentItem.point,
          parner: this.currentItem.parner,
          created_at: userName,
          updated_at: userName
        };
        try {
          this.loading(true);
          const res = await useJwt.put(url, updateParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.fetchNews();
            this.$bvModal.hide("modal-honor-detail");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
            return;
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi cập nhật tin",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        const createParams = {
          id: 0,
          cate_id: this.currentItem.cate_id,
          full_name: this.currentItem.full_name,
          status: this.currentItem.status,
          type_prize: this.currentItem.type_prize,
          image_path: this.currentItem.image_path,
          channel: this.currentItem.channel,
          point: this.currentItem.point,
          parner: this.currentItem.parner,
          created_at: userName,
          updated_at: userName
        };
        this.loading(true);
        const res = await useJwt.post("portal/honors/", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.fetchNews();
          this.$bvModal.hide("modal-honor-detail");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async isValidPo(item) {
      if (!item.full_name) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tên không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      if (!item.type_prize) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Loại giải không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      if (item.status == null || item.status === '' || item.status == undefined) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Trạng thái không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      if (!item.channel) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Kênh thoại không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      return true;
    },

    deleteRow(item) {
      this.currentItem = item;
      this.$bvModal.show('modal-confirm-delete-new');
    },
    async deletesNewConfirm() {
      try {
        this.loading(true);

        const res = await useJwt.delete("portal/honors/" + this.currentItem.id);
        this.$bvModal.hide('modal-confirm-delete-new');
        this.loading(false);
        if (res.data.code == 200) {
          this.fetchNews();
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Xóa Vinh danh nhân viên thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi xóa Chủ đề ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-knowledge-base.scss";
</style>
<style lang="css">
.cat-new .card {
  width: 100%;
  margin-bottom: 0 !important;
}

.cat-new .card-body {
  padding: 1rem !important;
  height: calc(100vh - 230px);
  overflow-y: auto;
  overflow-x: hidden;
}

.new-detail .card-body {
  height: calc(100vh - 215px);
}

.new-detail .form-group label {
  font-weight: 700;
  color: #000;
}

.new-detail .form-control,
.cat-new .select2-container .select2-selection--single .select2-selection__rendered {
  color: #000 !important;
}

.cat-sub .card-body {
  background: rgba(217, 217, 217, 0.1);
}

.bt-tonggle-collspan,
.bt-tonggle-expand {
  line-height: 40px;
  vertical-align: middle;
  align-items: center;
  padding-left: 0.2rem !important;
  padding: 10px 5px !important;
  line-height: 30px;
  float: right;
  margin-top: 6px;
}

.bt-tonggle-collspan .icon-img {
  content: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAFCAYAAACeuGYRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAChSURBVHgBdY69DcIwEIWfHXoudHQnoGAMRmGDZAOSCQgVLRuQDYANYAFksQAuEUIxz4WlCJGTTvfzvnu6bKFaylj2k1xeT+9vGAhyq1xky5zaEdCagCsCDnPVozL68JIz96cQEFMz4GySOFNd83jDVlnrj0VDw5JgEXXW6v5wu9ibvitNxQIFj6q0I9x0FrVzzqed+fd/fOndoSDcEr786l+DyzUZvfQQawAAAABJRU5ErkJggg==');
}

.bt-tonggle-expand .icon-img {
  content: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAFCAYAAACeuGYRAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAACBSURBVChTY/iPBZw4ceJ/c2PT/yePH0NFUAGKpo8fP4IVK8srwPHECRPA4sgArmn+3Hn/DXX1wHhifz9Y4cS+frBGe2ub/2tWr4aqBGq6dvXqfx9PL7BkVEQEhpMeA/kZaWlg+bLiErA8w7y5c8GCJ44fhyrDDtauWQM2fP7cuf8B+j/RB1rMEZUAAAAASUVORK5CYII=');
}

.cat-new .list-group {
  height: calc(100vh - 385px);
}

.tree-item {
  line-height: 26px;
  min-height: 26px;
  text-align: left;
  padding-left: 0.9rem;
  cursor: pointer;
}

.tree-item .hiden {
  display: none !important;
}

.tree-item-chi {
  line-height: 24px;
  min-height: 24px;
  text-align: left;
  padding-left: 2.2rem;
  cursor: pointer;
}

.item-sub {
  line-height: 26px;
  min-height: 26px;
  text-align: left;
  padding-left: 0.6rem;
  cursor: pointer;
}

.item-chi-active .div-item-text {
  background-color: #FF5A5A;
  border-radius: 10px;
  padding-left: 1rem !important;
  width: 80%;
  height: 28px;
}

.item-sub-active .div-item-text {
  background-color: #FF5A5A;
  border-radius: 10px;
  padding-left: 0.6rem;
  width: 80%;
}

.tree-item-text,
.tree-item-text-chi {
  color: #000 !important;
  font-size: 13px;
  font-weight: bold;
  font-family: 'Times New Roman';
  text-align: left;
  cursor: pointer;
}

.item-sub-text {
  color: #000 !important;
  font-size: 13px;
  font-family: 'Times New Roman';
  text-align: left;
  cursor: pointer;
}

.item-chi-active .tree-item-text-chi,
.item-sub-active .item-sub-text {
  color: white !important;
}

.tree-item-text-chi {
  padding-left: 0.8rem;
}

.item-chi-active {
  background-color: #ff5a5a;
  border-radius: 10px;
  margin: 0 0.5rem;
}

.title-cat {
  background: #FF5A5A;
  height: 32px;
  text-align: center;
  vertical-align: middle;
  line-height: 32px;
  font-family: 'Times New Roman';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  width: 92%;
  margin: 0 auto;
}

table {
  width: 100%;
  min-width: 500px;
}

.no-data label {
  font-size: 22px;
  font-weight: bold;
  color: #000;
}

.use-new .vgt-table td,
.use-new .vgt-table th {
  max-width: 300px;
  height: 65px !important;
  color: #000;
  padding: 0 8px !important;
  border: 1px solid #ccc;
}

.use-new table.vgt-table,
.use-new .vgt-table th {
  text-align: center;
}

.use-new .vgt-table.striped tbody tr:nth-of-type(odd) {
  background-color: #f1f1f1 !important;
  border-radius: 10px;
}

.vgt-wrap .vgt-table th.sortable:after {
  border-bottom-color: #ebe9f1;
}

.vgt-wrap__footer {
  padding: 1em;
  border: 1px solid #ebe9f1;
  background: linear-gradient(transparent, transparent);
}

.vgt-wrap__footer {
  color: #6e6b7b;
}


.vgt-table th.sortable:after {
  content: "";
  position: absolute;
  height: 0px;
  width: 0px;
  top: 50%;
}

.modal .modal-header {
  background-color: #ed1f24;
  color: black !important;
}

.modal-header h5 {
  color: black !important;
}

.use-new label {
  line-height: 50px;
  font-size: 1rem;
}

.btn-tree,
.btn-tree-parent {
  width: 16px;
  display: inline-flex;
}

.btn-tree-parent {
  margin-top: 10px;
}

@media only screen and (max-width: 1600px) {
  .btn-tree.btn-tree-parent {
    width: 15px;
    display: inline-flex;
  }

  .right-tonggle {
    padding-left: 0;
  }

  .bt-tonggle-collspan,
  .bt-tonggle-expand {
    padding: 10px 0px !important;
  }
}

.cat-new {
  font-family: 'Times New Roman';
  margin-top: -15px;
}

.cat-new .form-control {
  height: 28px;
  border-radius: 10px;
}

.cat-new .text-body:not(.group-item-active, .active) {
  font-family: 'Times New Roman';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: #000000 !important;
}

.group-item-active {
  background-color: #FF5A5A;
  border-radius: 10px;
  margin: 0;
  padding-left: 0.5rem;
  color: white !important;
}

.list-group.list-group-circle .list-group-item:hover {
  background-color: #FF5A5A;
  border-radius: 10px;
  opacity: 0.8;
  color: white;
}

.list-group .list-group-item {
  line-height: 7px;
  height: 26px;
  /* margin: 5px 0; */
}

.question-content-break {
  min-height: 330px;
  white-space: break-spaces;
  line-height: 2.5rem;
  text-align: left;
}

.input-group-merge {
  cursor: pointer;
}

.modal .modal-header {
  background-color: #ed1f24;
  color: black !important;
}

.modal-header h5 {
  color: black !important;
}


.not-padding {
  padding: 0 !important;
}

.not-padding-r {
  padding-right: 0 !important;
}

.phone-re {
  display: inline-block;
  width: 200px;
  margin-left: 20px;
  border: 1px solid #ddd;
  height: 30px;
  border-radius: 3px;
}

input:focus-visible {
  outline: none !important;
  border: 1px solid #ed1f24;
}

.confirm-text {
  color: #000;
  font-size: 13px !important;
}

.img-btn {
  width: 60px;
  cursor: pointer;
  margin: 0 20px;
}

.input-group-merge {
  cursor: pointer;
}


.list-group.list-group-circle .list-group-item:after {
  left: 10px;
  background-image: none;
}

.list-group.list-group-circle .list-group-item {
  padding-left: 0.5rem;
  text-align: left;
  cursor: pointer;
  border-radius: 10px;
}

.parent-item {
  background-color: #ede5e5;
  border-radius: 8px;
  padding: 0 5px;
  margin: 4px 0;
}

.search-new {
  height: 28px;
}

.search-new::placeholder {
  font-family: 'Times New Roman';
  font-style: italic;
  font-weight: 400;
  font-size: 13px;
  color: #000;
}

.input-group-text {
  color: #000;
}

.modal-xl {
  max-width: 70% !important;
  margin: 0 auto;
  padding-top: 4rem;
}

.use-new .form-group {
  border-bottom: 1px solid #ebe9f1;
}

.border-lr {
  border-left: 1px solid #ebe9f1;
  border-right: 1px solid #ebe9f1;
}

.border-left {
  border-left: 2px solid #ccc;
}

.font-bold {
  font-weight: bold;
}

.margin-b {
  margin-bottom: 0 !important;
}

.use-new .vgt-responsive {
  height: calc(100vh - 390px);
  background-color: #fff;
}

.hot-new {
  display: flex;
  width: 100%;
}

.hot-img {
  width: 240px;
}

.btn-add-item {
  background: #A5D798 !important;
  border: 1px solid #000000;
  border-radius: 10px;
  color: #000 !important;
  width: 100%;
  text-align: left;
  font-weight: 700;
  font-size: 13px;
}

#modal-confirm-delete .modal,
#modal-confirm-delete .modal-content {
  width: 580px;
  height: 226px;
  background: #fff;
  border-radius: 10px;
  border: 2px solid red;
  padding: 40px 20px;
  text-align: center;
}

.btn-save {
  font-size: 15px;
  font-family: 'Times New Roman';
  font-style: normal;
  min-width: 120px
}

.btn-back,
.btn-delete {
  font-size: 25px;
  font-family: 'Times New Roman';
  font-style: normal;
  min-width: 120px
}

.text-confirm-delete {
  font-family: 'Times New Roman';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
}

.bottom-delete {
  margin-top: 40px !important;
}

.cat-new .select2-container--default .select2-selection--single .select2-selection__rendered {
  line-height: 18px;
}

.cat-new .select2-container--classic .select2-selection--single,
.cat-new .select2-container--default .select2-selection--single {
  min-height: 0.714rem;
}

.dx-icon-inserttable::before {
  content: "\f130";
}

.btn-row {
  cursor: pointer;
  width: 20px;
  display: inline-flex;
}

.dx-button-has-text .dx-button-content {
  padding: 0;
}

.dx-datagrid .dx-row > td {
  padding: 0px;
}
</style>
